import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  size,
} from '@twistopayments/design-system/styles'

export const container = css`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 16px;
  list-style: none;
  row-gap: ${size[32]};
  padding: 0;

  ${breakpoint.up('smMd')} {
    grid-template-columns: repeat(3, 1fr);
  }
`
export const date = (theme: Theme) => css`
  color: ${theme.palette.text.title};
  margin-top: 10px;
`
export const title = (theme: Theme) => css`
  color: ${theme.palette.text.title};
`

export const card = css`
  display: flex;
  flex-direction: column;
`

export const image = css`
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: top left;
  border-radius: ${size[8]};
  ${breakpoint.up('smMd')} {
    max-width: 450px;
  }
`

export const description = css`
  margin-top: ${size[24]};
  font-size: ${fontSize.md};
  line-height: ${size[24]};

  ${breakpoint.up('smMd')} {
    margin-top: ${size[40]};
  }
`
